import { Crisp as CrispSDK } from 'crisp-sdk-web'
import { useEffect } from 'react'
import { z } from 'zod/v4'

const env = z
  .object({
    VITE_CRISP_WEBSITE_ID: z.string().optional(),
  })
  .parse(import.meta.env)

export const useCrisp = ({ show = true }: { show?: boolean } = {}) => {
  useEffect(() => {
    if (!env.VITE_CRISP_WEBSITE_ID) {
      return
    }
    // Already loaded?
    if (CrispSDK.isCrispInjected()) {
      return
    }

    /**
     * @note positioning etc. is configured at Crisp
     * @see https://app.crisp.chat/settings/account/interface/
     */
    CrispSDK.configure(env.VITE_CRISP_WEBSITE_ID, {
      /** Options here */
    })
  }, [])

  useEffect(() => {
    if (!env.VITE_CRISP_WEBSITE_ID) {
      return
    }
    if (show) {
      CrispSDK.chat.show()
    } else {
      CrispSDK.chat.hide()
    }
  }, [show])

  /** Always show on unload */
  useEffect(() => {
    return () => {
      if (!env.VITE_CRISP_WEBSITE_ID) {
        return
      }
      CrispSDK.chat.show()
    }
  }, [])

  return CrispSDK
}
